export const getWordCount = (query: string): number => (query.match(/\w+/g) || []).length;
